import React, { useContext, useEffect, useState } from 'react'
import { ReactFlowProvider } from '@xyflow/react'
import Organization3Layout from './organization3Layout'
import Loading from '../../component/loading'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import Position2Layout from '../position2Layout/position2Layout'
import { AppContextMenu } from '../../App'

function Organization3LayoutWithProvider() {
    const [loading, setLoading] = useState(false)
    const [selectedDepartment, setSelectedDepartment] = useState(false)
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('organizationLayout')
    }, [])
    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content" style={{ minHeight: '100vh' }}>
                    <Navbar />
                    <div className="flex maxLg:flex-col">
                        <div className="w-1/2 maxLg:w-full p-2 m-2 shadowBox">
                            <h1>بخش کاری</h1>
                            <ReactFlowProvider>
                                <Organization3Layout
                                    setSelectedDepartment={
                                        setSelectedDepartment
                                    }
                                />
                            </ReactFlowProvider>
                        </div>
                        <div className="w-1/2 maxLg:w-full p-2 m-2 shadowBox">
                            <h1>جایگاه شغلی</h1>
                            <ReactFlowProvider>
                                {selectedDepartment ? (
                                    <Position2Layout
                                        selectedDepartment={selectedDepartment}
                                    />
                                ) : null}
                            </ReactFlowProvider>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default Organization3LayoutWithProvider
